export const SIGN_IN_MODAL_VIEWS = [
  'sign-in',
  'create-account',
  'activate-account',
  'recovery',
  'reset-confirmation',
] as const;

export type SignInModalTab = typeof SIGN_IN_MODAL_VIEWS[number];

export type ForceableAuthModalView = 'sign-in' | 'create-account' | 'recovery';

export const FORCEABLE_AUTH_MODAL_VIEWS: readonly ForceableAuthModalView[] = ['sign-in', 'create-account', 'recovery'];

export interface SignInModalData {
  returnUrl?: string;
  tab?: SignInModalTab;
}
